let accordionH = {
	close: 0,
	open: 0
}
var achievement = {
	lang: "",
	init: function(){
		let path = location.pathname;
		let patharry = path.split("/");
		let lang = patharry[1];
		achievement.lang = lang;
		let url =`/jp/special/fp-series/assets/json/achievement_${lang}.json`;
		load.getJson(url, {}).done(function(json){
			achievement.makeHTML(json);
			loopGallery.init();
			graph.nav();
			cropZoom.init();
		});
		$("#directors_view a.btn_open").off().on("click", function(){
			$(".wrap_accordion_col2").addClass("active");
			$(".wrap_accordion_col2").css({
				"height": accordionH.open + "px"
			});
			setTimeout(function(){
				common.resize();
			}, 600);
		});
		$("#directors_view a.btn_close").off().on("click", function(){
			$(".wrap_accordion_col2").css({
				"height": accordionH.close + "px"
			});
			$(".wrap_accordion_col2").removeClass("active");
			setTimeout(function(){
				common.resize();
			}, 600);
		});
	},
	makeHTML: function(data){
		let HTML = "";
		//console.log(data);
		let linkTxt=  "";
		if(achievement.lang === "jp"){
			linkTxt = "スペシャルサイトへ";
		}else{
			linkTxt = "Special Site";
		}
		for(var i = 0; i < data.length; i++){
			let d = data[i];
			HTML += `<li class="a">
						<div class="col2">
							<div class="col_l">
								<div class="movie">
									<iframe width="560" height="315" src="https://www.youtube.com/embed/${d.youtubeID}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
								</div>
							</div>
							<div class="col_r">
								<div class="description">
									<div class="header">
										<h4>${d.title}</h4>
										<h5>${d.director}</h5>
									</div>
									<p><span>${d.text}</span></p>
									<div class="link"><a href="${d.link}" title="${linkTxt}" target="_blank" rel="noopener">${linkTxt}</a></div>
								</div>
							</div>
						</div>
					</li>`;
		}
		$(".list_performance ul").html(HTML);
		common.resize();
		setTimeout(function(){
			common.resize();
		}, 300);
	}
}
//loop gallery
let loopGallery = {
	init: function(){
		let x = 0;
		setInterval(function(){
			loop();
		}, 33);
		function loop(){
			if(isSmallScreen){
				x -= .5;
			}else{
				x -= 2;
			}
			if(x < $(".s0").eq(1).position().left*-1){
				x = 0;
			}
			$(".block_feature_slideshow ul").css({
				"transform": `translate3d(${x}px,0,0)`
			});
		}
	}
}
//switch sensitivity
let graph = {
	current: 0,
	nav: function(){
		graph.change();
		$(".nav_sensitivity li a").off().on("click", function(){
			graph.current = $(".nav_sensitivity li a").index(this);
			graph.change();
		})
	},
	change: function(){
		$(".nav_sensitivity ul").removeClass();
		$(".nav_sensitivity ul").addClass("current" + graph.current);
		$(".img_sensitivity li").removeClass("active");
		
		//active
		$(".img_sensitivity li").eq(graph.current).addClass("active");
		let arry = [
			"cinemacamera/download/fpl.jpg",
			"cinemacamera/download/fp.jpg"
			
		];
		$(".btn_download").attr("href", imgpath + arry[graph.current]);
	}
}